(function ($) {

	$('#Contact').submit(function(e) {
		e.preventDefault();

		var data = {
		  Name: $('#ContactName').val(),
		  Phone: $('#ContactPhone').val(),
		  Email: $('#ContactEmail').val(),
		  Message: $('#ContactMessage').val(),
		  Privacy: $('#Privacy').is(':checked') ? "Yes" : "No"
		};

		$.ajax({
		  type: "POST",
		  url: WP.AJAX_URL,
		  data: $.extend({ action: 'send_contact_data' }, data),
		  success: function(result){
		    $('#Contact').fadeOut(300).remove();
		    $('.contact-thankyou').delay(300).fadeIn(300);
		  },
		  error: function(result) {
		  	
		  }
		});  
	});

	// NUMBER ONLY FOR PHONE
	$('#ContactPhone').on('input', function (event) { 
	    this.value = this.value.replace(/[^0-9]/g, '');
	});

	restrictInput($('#ContactMessage'));

	function restrictInput($textInputMessage)
	{
	  var textInputMessageTypingTimer;
	  var textInputMessageDoneTypingInterval = 200;

	  $textInputMessage.on('keyup',function()
	  {
	    clearTimeout(textInputMessageTypingTimer);

	    textInputMessageTypingTimer = setTimeout(function()
	    {
	      $textInputMessage[0].value = $textInputMessage[0].value
	        .replace(/<\/?[^>]+(>|$)/g, '')
	        .replace(/(https?:\/\/[^\s]+)/g, '');

	    }, textInputMessageDoneTypingInterval);

	  });

	  $textInputMessage.on('keydown', function()
	  {
	    clearTimeout(textInputMessageTypingTimer);
	  });
	}
  
})(jQuery);
